export default __webpack_public_path__ + "static/media/foto3.4b6a88d8.jpg";